module.exports = __webpack_public_path__ + "img/jian01.5a556933.png";